import $ from 'jquery';
import moment from 'moment';
import { dateFormat, isTablet } from 'js/common/constants';

export default class SearchForm {
  constructor() {
    this.$search = document.querySelector('.js-search');
    this.$searchForm = document.querySelector('.js-search-form');
    this.$calendarButton = this.$searchForm.querySelector('.js-search-calendar-button');
    this.$checkInDate = this.$searchForm.querySelector('.js-search-check_in-date');
    this.$checkOutDate = this.$searchForm.querySelector('.js-search-check_out-date');
    this.$checkInDateInput = this.$searchForm.querySelector('.js-search-check_in-date-input');
    this.$checkInDay = this.$searchForm.querySelector('.js-search-check_in-day');
    this.$checkOutDay = this.$searchForm.querySelector('.js-search-check_out-day');
    this.$checkOutDateInput = this.$searchForm.querySelector('.js-search-check_out-date-input');
    this.$checkOutButton = this.$searchForm.querySelector('.js-search-check_out-button');
    this.$personPopover = this.$searchForm.querySelector('.js-search-person-popover');
    this.$personSelection = this.$searchForm.querySelector('.js-search-person-selection');
    this.$personSelectionSubmit = this.$searchForm.querySelector('.js-search-person-selection-submit');
    this.$personNumber = this.$searchForm.querySelector('.js-search-person-number');
    this.$adultText = this.$searchForm.querySelector('.js-search-form-adult-text');
    this.$childText = this.$searchForm.querySelector('.js-search-form-child-text');
    this.$childNumber = this.$searchForm.querySelector('.js-search-child-number');
    this.$childAgeInfo = this.$searchForm.querySelector('.js-search-child-age-info');
    this.$childWrapper = this.$searchForm.querySelector('.js-search-child-wrapper');
    this.$childDecrease = this.$searchForm.querySelector('.js-search-child-decrease');
    this.$childIncrease = this.$searchForm.querySelector('.js-search-child-increase');
    this.$adultDecrease = this.$searchForm.querySelector('.js-search-person-decrease');
    this.$adultIncrease = this.$searchForm.querySelector('.js-search-person-increase');
    this.childCount = 0;
    this.$currencyPopover = this.$searchForm.querySelector('.js-search-currency-popover');
    this.$currencySelection = this.$searchForm.querySelector('.js-search-currency-selection');
    this.$currencySelectionItem = this.$searchForm.querySelectorAll('.js-search-form-currency-item');
    this.$currencySelected = this.$searchForm.querySelector('.js-search-form-currency-selected');
    this.$currencyInput = this.$searchForm.querySelector('.js-search-form-currency-input');
    this.$searchToggleButton = document.querySelector('.js-search-toggle-button');

    if (this.$searchForm.length > 0) {
      this.init();
    }
  }

  init() {
    this.events();
    this.initCalendar();
  }

  events() {
    if (!isTablet) {
      this.$checkOutButton.addEventListener('click', () => {
        this.$calendarButton.click();
      });
    }

    this.$personPopover.addEventListener('click', (event) => {
      event.stopPropagation();
      this.$personSelection.classList.remove('d-none');
    });

    this.$personSelection.addEventListener('click', (event) => {
      event.stopPropagation();
      event.stopImmediatePropagation();
    });

    this.$currencyPopover.addEventListener('click', (event) => {
      event.stopPropagation();
      this.$currencySelection.classList.remove('d-none');
    });

    this.$currencySelection.addEventListener('click', (event) => {
      event.stopPropagation();
      event.stopImmediatePropagation();
    });

    // Adult Decrease
    this.$adultDecrease.addEventListener('click', () => {
      this.onAdultDecreaseClick();
    });

    // Adult Increase
    this.$adultIncrease.addEventListener('click', () => {
      this.onAdultIncreaseClick();
    });

    // Child Decrease
    this.$childDecrease.addEventListener('click', () => {
      this.onChildDecreaseClick();
    });

    // Child Increase
    this.$childIncrease.addEventListener('click', () => {
      this.onChildIncreaseClick();
    });

    // Popover & Tooltip Outside Click
    document.addEventListener('click', (event) => {
      if (!this.$personSelection.contains(event.target) && !this.$personPopover.contains(event.target)) {
        this.$personSelection.classList.add('d-none');
      }

      if (!this.$currencySelection.contains(event.target) && !this.$currencyPopover.contains(event.target)) {
        this.$currencySelection.classList.add('d-none');
      }
    }, true);

    // Currency Item Click
    this.$currencySelectionItem.forEach((item) => {
      item.addEventListener('click', (event) => {
        this.onCurrencyItemClick(event);
      });
    });

    this.$searchToggleButton && this.$searchToggleButton.addEventListener('click', () => {
      this.onSearchToggleClick();
    });

    this.$personSelectionSubmit && this.$personSelectionSubmit.addEventListener('click', () => {
      this.onPersonSelectionSubmit();
    });
  }

  onAdultDecreaseClick() {
    const _value = parseInt(this.$personNumber.value);
    if (_value > 1) {
      this.$personNumber.value = _value - 1;
      this.$adultText.textContent = `${_value - 1} ${window.Globals.adultText}`;
    }
  }

  onAdultIncreaseClick() {
    const _value = parseInt(this.$personNumber.value);
    this.$personNumber.value = _value + 1;
    this.$adultText.textContent = `${_value + 1} ${window.Globals.adultText}`;
  }

  onChildDecreaseClick() {
    const _value = parseInt(this.$childNumber.value);

    if (_value > 0) {
      this.childCount = _value - 1;
      this.$childNumber.value = this.childCount;

      if (this.childCount > 0) {
        this.$childText.textContent = `, ${this.childCount} ${window.Globals.childText}`;
      } else {
        this.$childAgeInfo.classList.add('d-none');
        this.$childText.textContent = '';
      }

      if (this.$childWrapper.lastChild) {
        this.$childWrapper.lastChild.remove();
      }
    }
  }

  onChildIncreaseClick() {
    const _value = parseInt(this.$childNumber.value);
    this.childCount = _value + 1;
    const selectElement = this.createSelectElement('search_form_child_age', this.childCount);

    this.$childNumber.value = this.childCount;
    this.$childText.textContent = `, ${this.childCount} ${window.Globals.childText}`;
    this.$childWrapper.append(selectElement);
    this.$childAgeInfo.classList.remove('d-none');
  }

  onCurrencyItemClick(event) {
    const _value = event.target.dataset.currency;
    const _text = event.target.textContent;

    this.$currencySelectionItem.forEach((item) => {
      item.classList.remove('active');
    });

    event.target.classList.add('active');
    this.$currencySelected.textContent = _text;
    this.$currencyInput.value = _value;
    this.$currencySelection.classList.add('d-none');
  }

  onSearchToggleClick() {
    this.$search.classList.toggle('d-none');
    this.$search.classList.toggle('mt20');
    this.$searchToggleButton.classList.toggle('active');
  }

  initCalendar() {
    if (this.$calendarButton) {
      if (isTablet) {
        $(this.$calendarButton).daterangepicker({
          'autoApply': true,
          'linkedCalendars': false,
          'showCustomRangeLabel': false,
          'minDate': window.Globals.minDate,
          'opens': 'right',
          'singleDatePicker': true
        }, (start) => {
          const _start = moment(start).format('DD MMMM YYYY').split(' ');
          const _startDay = moment(start).format('dddd');
          const _next = moment(start).add(1, 'd');
  
          this.$checkInDate.textContent = dateFormat(_start);
          this.$checkInDateInput.value = moment(start).format('DD/MM/YYYY');
          this.$checkInDay.textContent = _startDay;

          $(this.$checkOutButton).data('daterangepicker').minDate = _next;
          $(this.$checkOutButton).data('daterangepicker').startDate = _next;
          this.$checkOutDate.textContent = dateFormat(moment(_next).format('DD MMMM YYYY').split(' '));
          this.$checkOutDateInput.value = moment(_next).format('DD/MM/YYYY');
          this.$checkOutDay.textContent = moment(_next).format('dddd');
        });

        const checkOutMinDate = moment($(this.$calendarButton).data('daterangepicker').minDate, 'MMMM D, YYYY').add(1, 'd');

        $(this.$checkOutButton).daterangepicker({
          'autoApply': true,
          'linkedCalendars': false,
          'showCustomRangeLabel': false,
          'minDate': checkOutMinDate,
          'opens': 'right',
          'singleDatePicker': true
        }, (start) => {
          const _start = moment(start).format('DD MMMM YYYY').split(' ');
          const _startDay = moment(start).format('dddd');
  
          this.$checkOutDate.textContent = dateFormat(_start);
          this.$checkOutDateInput.value = moment(start).format('DD/MM/YYYY');
          this.$checkOutDay.textContent = _startDay;
        });
      } else {
        $(this.$calendarButton).daterangepicker({
          'autoApply': true,
          'linkedCalendars': true,
          'showCustomRangeLabel': false,
          'minDate': window.Globals.minDate,
          'startDate': window.Globals.startDate,
          'endDate': window.Globals.endDate,
          'opens': 'right'
        }, (start, end) => {
          const _start = moment(start).format('DD MMMM YYYY').split(' ');
          const _end = moment(end).format('DD MMMM YYYY').split(' ');
          const _startDay = moment(start).format('dddd');
          const _endDay = moment(end).format('dddd');
  
          this.$checkInDate.textContent = dateFormat(_start);
          this.$checkOutDate.textContent = dateFormat(_end);
          this.$checkInDateInput.value = moment(start).format('DD/MM/YYYY');
          this.$checkOutDateInput.value = moment(end).format('DD/MM/YYYY');
          this.$checkInDay.textContent = _startDay;
          this.$checkOutDay.textContent = _endDay;
        });
      }
    }
  }

  createSelectElement(name, value) {
    const select = document.createElement('select');
    select.name = `${name}_${value}`;
    select.className = 'form-control js-search-child-age-input';
    
    for (let i = 0; i < window.Globals.childMaxAge; i++) {
      const option = document.createElement('option');
      option.value = i===0 ? '' : i;
      option.textContent = i===0 ? `${value}. ${window.Globals.childText}` : i;
      select.append(option);
    }
    
    return select;
  }

  onPersonSelectionSubmit() {
    document.querySelector('.js-search-person-selection').classList.add('d-none');
  }
}


/** WEBPACK FOOTER **
 ** ./assets/js/modules/searchForm.js
 **/